import type { SVGProps } from 'react';
const SvgNavServicesFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M11 15v-2h2v2zm-1-9h4V4h-4zM4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19v-4h7v1q0 .424.287.712Q9.576 17 10 17h4q.424 0 .713-.288A.97.97 0 0 0 15 16v-1h7v4q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21zm-2-8V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h4V4q0-.824.588-1.412A1.93 1.93 0 0 1 10 2h4q.825 0 1.412.587Q16 3.176 16 4v2h4q.824 0 1.413.588Q22 7.175 22 8v5h-7v-1a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 11h-4a.97.97 0 0 0-.713.287A.97.97 0 0 0 9 12v1z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavServicesFilled;
